var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"nextStep",attrs:{"loading":_vm.loading,"loadingText":"提交中...","type":"danger","text":"下一步","disabled":_vm.isDisabled,"click":_vm.preClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }